import { useToggle } from "client/hooks/utils/useToggle";
import { Popup } from "components/common/Popup/Popup";
import { ChromePicker, HuePicker } from "react-color";

interface ColorInputProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
}

export const ColorInput = ({ label, value, onChange }: ColorInputProps) => {
    const { isOpen, onClose, toggle } = useToggle();
    return (
        <div className="flex flex-col gap-4">
            <label className="font-semibold">{label}</label>
            <Popup
                isOpen={isOpen}
                close={onClose}
                content={
                    <div className="absolute bottom-full left-0 w-[200px] lg:w-[300px] mb-4 flex flex-col gap-4 bg-white dark:bg-darkSurface-200 rounded-md shadow-lg border border-irGray-200 dark:border-darkSurface-600 px-4 py-4">
                        <ChromePicker
                            disableAlpha={true}
                            color={value}
                            onChange={(value) => onChange(value.hex)}
                            styles={{
                                default: {
                                    body: {
                                        display: "none",
                                    },
                                    picker: {
                                        width: "100%",
                                        height: "auto",
                                        boxShadow: "",
                                        borderRadius: "0.25rem",
                                        overflow: "hidden",
                                    },
                                },
                            }}
                        />
                        <HuePicker
                            styles={{
                                default: {
                                    picker: {
                                        borderRadius: "0.5rem",
                                        overflow: "hidden",
                                        width: "100%",
                                    },
                                },
                            }}
                            color={value}
                            onChange={(value) => onChange(value.hex)}
                        />
                    </div>
                }
            >
                <div className="flex px-1 py-1 border rounded-md border-irGray-400 dark:border-darkSurface-600">
                    <input
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        type="text"
                        className="w-full bg-transparent outline-none"
                    />
                    <button
                        className="flex-shrink-0 w-6 h-6 border rounded-md cursor-pointer border-irGray-400 dark:border-darkSurface-600"
                        style={{ backgroundColor: value }}
                        onClick={toggle}
                    ></button>
                </div>
            </Popup>
        </div>
    );
};
